import React from 'react';
import { Actions } from '../../core/modules/Actions';
import { ModuleEvents } from './Actions';
// import {navigate} from '../../core/repository/Repository';
import { onToast } from '../../core/Constant';

export default {
  [ModuleEvents.UPLOAD_VIDEO]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.video.fetchVideo());
    onToast('Upload Status', payload);
  },
  [ModuleEvents.FETCH_ALL_VIDEO]: ({ dispatch, payload, appState }) => {
    const regeneratingVideoId = appState.video.get("regeneratingVideoId");
    if (!regeneratingVideoId) {
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data?.data)
          ? payload.data?.data
          : [];
      const processingVideo = list.find(
        (item) =>
          item?.subtitle_status === "processing" ||
          (typeof item?.subtitle_status === "string" &&
            item.subtitle_status.toLowerCase() === "processing")
      );
      if (processingVideo) {
        dispatch(Actions.video.setRegeneratingVideoId(processingVideo.id));
      }
    }
  },
  [ModuleEvents.DELETE_VIDEO]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.video.fetchVideo());
    onToast('Delete Video', payload);
  },
  [ModuleEvents.UPDATE_TITLE]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.video.fetchVideo());
    onToast('Update Title', payload);
  },
  [ModuleEvents.FETCH_SUBTITLE_STATUS]: ({ dispatch, payload, appState }) => {
    const data = payload?.data || payload;
    const status = data?.status;
    if (status && String(status).toLowerCase() === 'completed') {
      dispatch(Actions.video.fetchVideo());
    }
  },
  [ModuleEvents.REGENERATE_SUBTITLES]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code) {
      onToast("Regenerating Subtitles", payload, false);
    } else {
      const fallbackResponse = {
        status_code: "1",
        message: "Subtitle regeneration process started successfully.",
      };
      onToast("Regenerating Subtitles", fallbackResponse, false);
    }
  },
};
